import React from 'react';
import * as e from '../elements';

export default {
  name: 'Simple Cover',
  description: 'Minimal text with expansive edge-to-edge backdrop',
  thumb: 'cover-simple',
  tags: ['Cover'],
  jsx: (
    <e.PBlock
      height="full"
      pad="md"
      backgroundMediaUrlsafe="ahBwYWdlaGl0cy1iYWNrZW5kciQLEgVTcGFjZRiAgID48vWbCgwLEgVNZWRpYRiAgIC4upGQCQyiAQRwcm9k"
    >
      <div className="row align-items-center">
        <div className="col-12 col-md-10 col-lg-8 mx-auto text-center">
          <e.PText
            size="header-h1"
            color="white-hi"
            shadow="hard"
            className="my-3"
            text="Product Name"
          />
          <e.PText
            text="Our one-liner slogan"
            color="white-md"
            shadow="hard"
            size="header-h3"
            className="my-3"
          />
          <e.PText
            size="text-md"
            className="my-3"
            color="white-md"
            shadow="hard"
            text="A brief explanation about the product. What it is. How it is going to change the world. And how it is better than its rivals."
          />
        </div>
      </div>
    </e.PBlock>
  ),
};



// WEBPACK FOOTER //
// ./scripts/components/editor/blocks/CoverSimple.jsx